export interface CompanySettingsValues { // CompanySettingsData from CompanySettingsController.cs
    CompanyID: number;
    FieldID: number;
    FieldType: CompanySettingsType;
    FieldGroup: string;
    FieldName: string;
    DisplayName: string;
    NumericValue: number;
    TextValue: string;
    Options: CompanySettingsOptions[];
}

export interface CompanySettingsOptions { // CompanyFieldOptionDTO.cs
    DisplayValue: string;
    NumericValue: number;
    TextValue: string;
}

export enum CompanySettingsType { // FieldType from AdminEnums.cs
    Number = 0,
    Text = 1,
    Boolean = 2,
    Select = 3,
    File = 4
}

export interface FieldGroup { //FieldGroup object to hold internal english value and Localized Display value
    GroupName: string;
    DisplayName: string;
}

export interface SSOSettingsValues { //values to hold sso settings values
    EnableSSO: boolean;
    SSOClientID: string;
    SSOClientSecret: string;
    SSOIdentityProviderURL: string;
    SSOProvider: string;
}
